import React from 'react';
import types from './types';
import percentToHex from '../PercentToHex';
import UIEditorSubcomponent from '../UIEditorSubcomponent';
import Scenario from '../../../classes/scenarioElements/Scenario';
import TextVariables from '../../../classes/TextVariables';

export default function UIHeaders(props)
{
	let properties = {};
	for (let i = 1; i <= props.size; i++)
	{
		properties['header ' + i.toString() + ' properties'] = {
			type: 'group',
			default: false,
			title: 'Header ' + i.toString(),
		}
		properties['header ' + i.toString() + ' visible'] = {
			type: 'toggle',
			default: true
		}
		properties['header ' + i.toString() + ' text'] = {
			type: 'text',
			default: 'Header ' + i.toString()
		}
		properties['header ' + i.toString() + ' link'] = {
			type: 'step',
		}
		properties['header ' + i.toString() + ' text color'] = {
			type: 'color',
			default: '#ffffff'
		}
		properties['header ' + i.toString() + ' background color'] = {
			type: 'color',
			default: '#4f4f4f'
		}
		properties['header ' + i.toString() + ' shadow color'] = {
			type: 'color',
			default: '#000000'
		}
		properties['header ' + i.toString() + ' text alpha'] = {
			type: 'range',
			default: 100,
			step: 1,
		}
		properties['header ' + i.toString() + ' background alpha'] = {
			type: 'range',
			default: 100,
			step: 1,
		}
		properties['header ' + i.toString() + ' shadow alpha'] = {
			type: 'range',
			default: 100,
			step: 1,
		}
	}

	const extraPorperties = {
		// 'text color': {
		// 	type: 'color',
		// 	default: '#ffffff'
		// },
		// 'background color': {
		// 	type: 'color',
		// 	default: '#4f4f4f'
		// },
		// 'shadow color': {
		// 	type: 'color',
		// 	default: '#000000'
		// },
		// 'text alpha': {
		// 	type: 'range',
		// 	default: 100
		// },
		// 'background alpha': {
		// 	type: 'range',
		// 	default: 100
		// },
		// 'shadow alpha': {
		// 	type: 'range',
		// 	default: 100
		// },
		'anchor': {
			type: 'anchor',
			default: props.anchor ? props.anchor : 'center'
		},
		'alignment': {
			type: 'align',
			default: props.align ? props.align : 'middle'
		},
		'header spacing': {
			type: 'range',
			default: 10
		},
		'visible': {
			type: 'toggle',
			default: true
		}
	}

	const hiddenProperties = {
		'text color': {
			type: 'color',
			default: '#ffffff'
		},
		'background color': {
			type: 'color',
			default: '#4f4f4f'
		},
		'shadow color': {
			type: 'color',
			default: '#000000'
		},
		'text alpha': {
			type: 'range',
			default: 100
		},
		'background alpha': {
			type: 'range',
			default: 100
		},
		'shadow alpha': {
			type: 'range',
			default: 100
		},
	}

	if(props.getProperties)
	{
		return { ...properties, ...extraPorperties };
	}

	function calculateTextSize(label, max, min, eMax, eMin, limit1, limit2)
	{
		return props.context === 'simulation' ? (label.length > limit1 ? label.length > limit2 ? min : max-((max-min) / 2) : max) : ((label.length > limit1 ? label.length > limit2 ? eMin : eMax-((eMax-eMin) / 2) : eMax) * props.scale);
	}

	properties = Object.assign({}, properties, extraPorperties);

	if (props.context === 'editor')
	{
		return (
			<UIEditorSubcomponent
				title={'Headers'}
				subcomponent={types.HEADERS}
				properties={properties}
				{...props}
			/>
		)
	}
	else if (props.data.visible)
	{
		const data = props.data;
		const simulation = props.context === "simulation";

		//build array from headers
		let headers = [];
		let firstVisible = true;
		let currIdx = 1;
		if(data['visible'].value === true)
			while (data['header ' + currIdx + ' text'])
			{
				if (data['header ' + currIdx + ' visible'].value)
				{

					const label = TextVariables.textToData(data['header ' + currIdx + ' text'].value);
					const link = data['header ' + currIdx + ' link'].value;
					const textAlpha = percentToHex(data['header ' + currIdx + ' text alpha'] ? data['header ' + currIdx + ' text alpha'].value : data['text alpha'] ? data['text alpha'].value : 100);
					const textColor = (  data['header ' + currIdx + ' text color']?.value ??  data['text color']?.value ?? '#ffffff') + textAlpha;
					const backgroundAlpha = percentToHex(  data['header ' + currIdx + ' background alpha'] ? data['header ' + currIdx + ' background alpha'].value :  data['background alpha'] ? data['background alpha'].value : 100);
					const backgroundColor = ( data['header ' + currIdx + ' background color']?.value ??  data['background color']?.value ?? '#4f4f4f') + backgroundAlpha;
					const shadowAlpha = percentToHex(data['header ' + currIdx + ' shadow alpha'] ? data['header ' + currIdx + ' shadow alpha'].value :  data['shadow alpha'] ? data['shadow alpha'].value : 100);
					const shadowColor = (data['header ' + currIdx + ' shadow color']?.value ??  data['shadow color']?.value ?? '#000000' ) + shadowAlpha;

					headers.push(
						<div key={currIdx}
							className={['uiHeader', simulation ? 'simulation' : ''].join(' ')}
							data-name={"ui-header-" + currIdx}
							style={{
								backgroundColor: backgroundColor,
								marginLeft: !firstVisible ? (data['header spacing'].value / 20) + '%' : 0,
								borderColor: shadowColor,
								color: textColor,
								fontSize: simulation ? "28px" : "0.85vw",

							}}
							onClick={(e) =>
							{
								if (link && Scenario.getStep(link))
								{
									Scenario.setCurrentStep(Scenario.getStep(link));
								}
							}}
						>
							{label}
						</div>
					);

					firstVisible = false;
				}

				++currIdx;
			}

		return (
			<div className={"uiHeadersRoot"}
				data-name='ui-preview-headers'
				data-anchor={data['anchor'].value}
				data-alignment={data['alignment'].value}
			>
				{headers}
			</div>
		);
	}

	return null;
}